import { wencesApi } from "@/api/wencesApi";

/**
 * Permite acceso si el usuario es admin O tiene permiso de traducciones
 * (translation_view o translation_edit). Los no-admin solo pueden usar "Solo este cliente".
 */
export default async function translationModuleGuard(to, from, next) {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      next("/login");
      return;
    }

    const roleResponse = await wencesApi.get("/api/users/myrole", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!roleResponse.data?.success) {
      next("/login");
      return;
    }

    const roleName = roleResponse.data.data?.role;
    const permissions = roleResponse.data.data?.permissions || [];

    const isAdmin = roleName === "admin";
    const hasTranslationPermission = permissions.some(
      (p) =>
        (p && String(p).toLowerCase()) === "translation_view" ||
        (p && String(p).toLowerCase()) === "translation_edit"
    );

    if (isAdmin || hasTranslationPermission) {
      next();
    } else {
      next("/dashboard");
    }
  } catch (error) {
    console.error("Error in translation module guard:", error);
    next("/login");
  }
}
